import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { NbDialogRef } from "@nebular/theme";
import { ShopService } from "../../services/shop.service";

@Component({
  selector: "ngx-dialog-receipt-prompt",
  templateUrl: "dialog-receipt-prompt.component.html",
  styleUrls: ["dialog-receipt-prompt.component.scss"],
})
export class DialogReceiptPromptComponent {
  @Input() uid: string;

  constructor(
    protected ref: NbDialogRef<DialogReceiptPromptComponent>,
    public shopService: ShopService,
    private router: Router
  ) {}

  cancel() {
    this.ref.close();
  }

  onRetail() {
    this.router.navigateByUrl(`/receipt/${this.uid}`);
    this.ref.close();
  }

  onReceiptPurchase() {
    this.router.navigateByUrl(`/receiptpurchase/${this.uid}`);
    this.ref.close();
  }

  onTrade() {
    this.router.navigateByUrl(`/trade/${this.uid}`);
    this.ref.close();
  }
}
